import { Link } from 'react-router-dom';

const contactOptions = [
  {
    icon: 'ri-chat-1-line',
    label: 'LINE 洽詢',
    desc: '掃描 QR Code 或點擊連結，直接加入 LINE 與業務聊天',
    action: '加入 LINE',
    href: 'https://lin.ee/X7Hcpf4',
    color: '#4CAF50',
    bg: '#f0faf0',
  },
  {
    icon: 'ri-phone-line',
    label: '電話諮詢',
    desc: '週一至週五 09:00–18:00，專人接聽您的諮詢電話',
    action: '撥打電話',
    href: 'tel:04-22029858',
    color: '#2e7d32',
    bg: '#e8f5e9',
  },
  {
    icon: 'ri-mail-line',
    label: 'Email 詢價',
    desc: '發送需求信件，業務將在一個工作天內回覆並提供報價',
    action: '寄送 Email',
    href: 'mailto:natural1070606@gmail.com',
    color: '#388e3c',
    bg: '#f1f8e9',
  },
];

export default function PartnershipCtaSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        {/* Top banner */}
        <div className="relative rounded-3xl overflow-hidden mb-12">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20lush%20green%20forest%20landscape%20from%20above%2C%20vibrant%20rich%20emerald%20green%20nature%2C%20wellness%20health%20concept%20background%2C%20beautiful%20natural%20texture%20pattern&width=1400&height=400&seq=partner-cta-bg-01&orientation=landscape"
              alt="合作洽詢背景"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-[#1a3a1a]/80" />
          </div>
          <div className="relative z-10 px-8 lg:px-14 py-14 text-center">
            <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5">
              開始合作
            </span>
            <h2 className="text-white font-bold leading-tight mb-5">
              準備好開始合作了嗎？<br />讓我們一起把您的想法變成產品
            </h2>
            <p className="text-green-200 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto mb-8">
              不論您的需求大小，康永生技的業務團隊都會認真對待每一個合作機會，提供最專業的建議與服務。
            </p>
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              立即填寫諮詢表單
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>

        {/* Contact options */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {contactOptions.map((opt) => (
            <div
              key={opt.label}
              className="rounded-2xl p-7 border border-gray-100 transition-all duration-300 hover:border-green-200 hover:-translate-y-1"
              style={{ backgroundColor: opt.bg }}
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-5"
                style={{ backgroundColor: `${opt.color}20` }}
              >
                <i className={`${opt.icon} text-2xl`} style={{ color: opt.color }} />
              </div>
              <h3 className="text-[#1a2e1a] font-bold text-[1.0625rem] mb-2">{opt.label}</h3>
              <p className="text-gray-500 text-[0.875rem] leading-[1.75] mb-5">{opt.desc}</p>
              <a
                href={opt.href}
                rel="nofollow"
                className="whitespace-nowrap inline-flex items-center gap-2 font-semibold text-[0.9375rem] transition-colors duration-200 cursor-pointer"
                style={{ color: opt.color }}
              >
                {opt.action}
                <i className="ri-arrow-right-line text-sm" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
